export enum ReportTabTypeEnum {
    custom = "CUSTOM",
    profile = "PROFILE",
    kpi = "KPI"
}
